<script setup lang="ts">
import { BlockBannerTiles } from '~/lib/services/content/content.blocks.dtos'

defineProps<{
  block: BlockBannerTiles
}>()

const isMobile = inject('isMobile')
const isTablet = inject('isTablet')
</script>

<template>
  <section class="flex w-full flex-col gap-8 px-4 py-8 lg:flex-row">
    <figure v-for="tile in block.bannerTiles" :key="tile.id" class="w-full rounded-md shadow-md">
      <img
        v-if="!isMobile && !isTablet && tile.imageDesktop"
        class="h-64 w-full rounded-t-md object-cover shadow-elevation-up lg:h-[256px]"
        :src="tile.imageDesktop.url"
        :alt="tile.imageDesktop.alternativeText || undefined"
      />
      <img
        v-if="(isMobile || isTablet) && tile.imageMobile"
        class="h-64 w-full rounded-t-md object-cover shadow-elevation-up"
        :src="tile.imageMobile.url"
        :alt="tile.imageMobile.alternativeText || undefined"
      />
      <div class="p-12">
        <header class="h-full md:min-h-[144px] lg:min-h-[72px]">
          <h2 class="text-[32px] font-bold leading-9 tracking-[-0.15px]">{{ tile.title }}</h2>
        </header>
        <section class="mb-8 mt-4 h-full md:min-h-[80px] lg:min-h-[48px]">
          <p class="text-sm leading-4 tracking-[-0.15px]">{{ tile.content }}</p>
        </section>
        <footer v-if="tile.primaryBtn" class="flex items-start">
          <SimpleLink :link="tile.primaryBtn">
            <McdButton is-primary class="w-40">
              {{ tile.primaryBtn?.title }}
            </McdButton>
          </SimpleLink>
        </footer>
      </div>
    </figure>
  </section>
</template>
